import axios from 'axios';
import { API_URL } from '../config';

// Módulo plano — no necesita ser un hook de React
const api = {

  getAsientosBySala: async (sala, token) => {
    try {
      const res = await axios.get(`${API_URL}/api/v1/asientos?sala=${sala}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (err) {
      return err.response?.data ?? { error: err.message };
    }
  },

  createAsiento: async (asiento, token) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/v1/asientos`,
        {
          numero:   asiento.numero,
          x:        asiento.x,
          y:        asiento.y,
          width:    asiento.width,
          height:   asiento.height,
          rotation: asiento.rotation,
          sala:     parseInt(asiento.sala, 10),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res.data;
    } catch (err) {
      return err.response?.data ?? { error: err.message };
    }
  },

  updateAsiento: async (asiento, token) => {
    try {
      const res = await axios.patch(
        `${API_URL}/api/v1/asientos/${asiento.id}`,
        {
          numero:   asiento.numero,
          x:        asiento.x,
          y:        asiento.y,
          width:    asiento.width,
          height:   asiento.height,
          rotation: asiento.rotation,
          sala:     parseInt(asiento.sala, 10),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res.data;
    } catch (err) {
      return err.response?.data ?? { error: err.message };
    }
  },

  getEstados: async (funcion, token) => {
    try {
      // El backend filtra por "producto" (id_woo), no por "funcion" — con el
      // nombre equivocado el filtro quedaba vacío y devolvía toda la tabla
      // Asientos_Estado sin distinguir evento/función.
      const res = await axios.get(`${API_URL}/api/v1/asientos_estado?producto=${funcion}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (err) {
      return err.response?.data ?? { error: err.message };
    }
  },

  getSala: async (id, token) => {
    try {
      const res = await axios.get(`${API_URL}/api/v1/salas/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (err) {
      return err.response?.data ?? { error: err.message };
    }
  },

  getSalaByNombre: async (zona, token) => {
    try {
      const res = await axios.get(`${API_URL}/api/v1/salas?nombre=${zona}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (err) {
      return err.response?.data ?? { error: err.message };
    }
  },
};

export default api;
